import { useEffect, useState } from 'react';
import { ApiClientError } from './api.js';
import { Button } from './ui.js';

export function isRequestRateLimited(error: unknown): error is ApiClientError {
  return error instanceof ApiClientError && error.code === 'RATE_LIMITED' && error.status === 429;
}

export function preserveChatOnRateLimit(
  timeline: unknown,
  conversation: unknown,
  errors: unknown[],
) {
  const failures = errors.filter(Boolean);
  return Boolean(
    timeline && conversation && failures.length && failures.every(isRequestRateLimited),
  );
}

export function ChatRateLimitNotice({
  error,
  retry,
}: {
  error: ApiClientError;
  retry: () => void;
}) {
  const [remaining, setRemaining] = useState(error.retryAfterSeconds ?? 10);
  useEffect(() => {
    const until = Date.now() + (error.retryAfterSeconds ?? 10) * 1_000;
    setRemaining(error.retryAfterSeconds ?? 10);
    const timer = window.setInterval(() => {
      const seconds = Math.max(0, Math.ceil((until - Date.now()) / 1_000));
      setRemaining(seconds);
      if (seconds === 0) {
        window.clearInterval(timer);
        retry();
      }
    }, 1_000);
    return () => window.clearInterval(timer);
  }, [error, retry]);
  return (
    <aside role="status" aria-live="polite">
      <p>
        Короткая пауза: достигнут лимит запросов.{' '}
        {remaining > 0 ? `Обновим чат через ${remaining} сек.` : 'Можно повторить обновление.'}
      </p>
      <Button tone="secondary" disabled={remaining > 0} onClick={retry}>
        Повторить обновление
      </Button>
    </aside>
  );
}
